import { render, staticRenderFns } from "./OrderMetalComponents.vue?vue&type=template&id=1324a979&"
import script from "./OrderMetalComponents.vue?vue&type=script&lang=js&"
export * from "./OrderMetalComponents.vue?vue&type=script&lang=js&"
import style0 from "./OrderMetalComponents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports